import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import TrustSection from './components/TrustSection';
import ArticlePreview from './components/ArticlePreview';
import FullscreenCTA from './components/FullscreenCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <TrustSection />
        <ArticlePreview />
        <FullscreenCTA />
      </main>
      <Footer />
    </>
  );
}